/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.sync.getRepoStatus'

export { $nsid }

/** Get the hosting status for a repository, on this server. Expected to be implemented by PDS and Relay. */
const main = l.query(
  $nsid,
  l.params({ did: l.string({ format: 'did' }) }),
  l.jsonPayload({
    did: l.string({ format: 'did' }),
    active: l.boolean(),
    status: l.optional(
      l.string<{
        knownValues: [
          'takendown',
          'suspended',
          'deleted',
          'deactivated',
          'desynchronized',
          'throttled',
        ]
      }>(),
    ),
    rev: l.optional(l.string({ format: 'tid' })),
  }),
  ['RepoNotFound'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
